import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PaperPlaneTilt, WarningCircle } from "@phosphor-icons/react";
import { PreviewPanel } from "./PreviewPanel";
import { FollowupForm } from "./CampaignParts";
import { unknownVars } from "./render";

// Récapitulatif obligatoire avant l'envoi : destinataires réels (calculés par le serveur), objet, contenu, relance.
export function ReviewDialog({ open, onClose, c, fu, setFu, onSend, busy }) {
  const [ack, setAck] = useState(false);
  useEffect(() => { if (open) setAck(false); }, [open]);
  const n = c.recipients.length;
  const unknown = unknownVars(c.subject, c.body_html);
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-surface border-border w-[95vw] max-w-3xl max-h-[92vh] flex flex-col overflow-hidden p-0" data-testid="lead-campaign-confirm-dialog">
        <DialogHeader className="px-6 pt-6">
          <DialogTitle>Vérifier avant l'envoi</DialogTitle>
          <DialogDescription>Seuls les destinataires listés ci-dessous recevront cet email, une seule fois par adresse.</DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto px-6 pb-4 space-y-4 flex-1 min-h-0">
          <div className="grid sm:grid-cols-3 gap-2 text-xs">
            <div className="border border-border rounded-md p-2"><div className="text-muted">Expéditeur</div><div className="text-fg font-mono break-all">{c.sender?.email}</div></div>
            <div className="border border-border rounded-md p-2"><div className="text-muted">Destinataires</div><div className="text-fg text-base font-semibold" data-testid="lead-review-count">{n}</div></div>
            <div className="border border-border rounded-md p-2"><div className="text-muted">Écartés de la sélection</div><div className="text-fg text-base font-semibold" data-testid="lead-review-skipped-count">{c.skipped.length}</div></div>
          </div>
          <div>
            <div className="text-xs text-muted mb-1">Destinataires</div>
            <div className="border border-border rounded-md max-h-44 overflow-y-auto divide-y divide-border/60" data-testid="lead-review-recipients">
              {c.recipients.map((r) => (
                <div key={r.key} className="flex flex-wrap justify-between gap-x-3 px-2 py-1.5 text-xs" data-testid={`lead-review-recipient-${r.key}`}>
                  <span className="text-fg">{r.contact_name || "Sans nom"} <span className="text-muted">· {r.company}</span></span>
                  <span className="font-mono text-[11px] text-fg break-all">{r.email}{!r.verified && <span className="text-muted"> (non vérifiée)</span>}</span>
                </div>
              ))}
            </div>
          </div>
          {c.skipped.length > 0 && (
            <div className="text-[11px] text-amber-500 space-y-0.5" data-testid="lead-review-skipped">
              {c.skipped.map((s) => <div key={s.key || s.siren}>Non envoyé : {s.contact_name || s.email || "contact"} ({s.name}) — {s.reason}</div>)}
            </div>
          )}
          <div className="border-t border-border pt-3"><PreviewPanel cid={c.id} recipients={c.recipients} testid="lead-review-preview" /></div>
          {unknown.length > 0 && <p className="text-xs text-destructive flex gap-1"><WarningCircle size={14} className="shrink-0" /> Variables inconnues : {unknown.map((v) => `{{${v}}}`).join(", ")}. Corrigez le message avant l'envoi.</p>}
          <FollowupForm fu={{ ...fu, subject: fu.subject || `Re : ${c.subject}` }} setFu={setFu} />
          <label className="flex items-start gap-2 text-xs text-fg">
            <input type="checkbox" className="mt-0.5" checked={ack} onChange={(e) => setAck(e.target.checked)} data-testid="lead-review-ack" />
            J'ai vérifié les destinataires, l'objet et le contenu du message, conformément aux règles de prospection B2B.
          </label>
        </div>
        <div className="border-t border-border px-6 py-3 flex flex-wrap items-center justify-end gap-2 bg-surface">
          <button onClick={onClose} className="text-sm text-muted hover:text-fg px-3 py-2" data-testid="lead-review-cancel">Revenir à la préparation</button>
          <button onClick={onSend} disabled={busy || !ack || !n || unknown.length > 0} data-testid="lead-campaign-send-confirm"
            className="bg-accent text-black font-semibold rounded-md px-4 py-2.5 text-sm flex items-center gap-1.5 disabled:opacity-50">
            <PaperPlaneTilt size={14} /> {busy ? "Envoi…" : `Envoyer à ${n} destinataire(s)`}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
